<div id="loading-spinner-container">
  <mat-spinner [diameter]="diameter" color="accent"></mat-spinner>
</div>
